import Input from './Input';
import PasswordInput from './PasswordInput';

export { PasswordInput };
export default Input;
